import { IconDefinition } from './icon-definition.model';

/**
 * All custom icons used across the app.
 * Add new icons here; they'll be registered automatically on bootstrap.
 *
 * Reference in templates:
 *   <mat-icon svgIcon="pg:billshark-logo"></mat-icon>
 *   <mat-icon svgIcon="pg:phone"></mat-icon>
 */
export const CUSTOM_ICONS: IconDefinition[] = [
  {
    namespace: 'pg',
    name: 'attach_file_add',
    url: 'icons/custom/attach_file_add.svg',
  },
  {
    namespace: 'pg',
    name: 'match_word',
    url: 'icons/custom/match_word.svg',
  },
  {
    namespace: 'pg',
    name: 'prompt_suggestion',
    url: 'icons/custom/prompt-suggestion.svg',
  },
  {
    namespace: 'pg',
    name: 'rollover',
    url: 'icons/custom/rollover.svg',
  },
  {
    namespace: 'pg',
    name: 'progress_activity',
    literal: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M11.994 21C10.7595 21 9.59575 20.7642 8.50275 20.2925C7.40975 19.8208 6.45517 19.177 5.639 18.361C4.823 17.5448 4.17917 16.5903 3.7075 15.4973C3.23583 14.4043 3 13.2405 3 12.006C3 10.7567 3.23683 9.58625 3.7105 8.49475C4.18433 7.40342 4.82733 6.45167 5.6395 5.6395C6.45167 4.82733 7.40658 4.18433 8.50425 3.7105C9.60175 3.23683 10.767 3 12 3C12.1417 3 12.2604 3.048 12.3562 3.144C12.4521 3.24 12.5 3.35892 12.5 3.50075C12.5 3.64258 12.4521 3.76125 12.3562 3.85675C12.2604 3.95225 12.1417 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 11.8577 20.048 11.7388 20.144 11.6433C20.24 11.5478 20.3589 11.5 20.5008 11.5C20.6426 11.5 20.7613 11.5479 20.8568 11.6438C20.9523 11.7396 21 11.8583 21 12C21 13.233 20.7632 14.3982 20.2895 15.4957C19.8157 16.5934 19.1727 17.5483 18.3605 18.3605C17.5483 19.1727 16.5966 19.8157 15.5053 20.2895C14.4138 20.7632 13.2433 21 11.994 21Z" fill="white"/>
    </svg>`,
  },
  {
    namespace: 'pg',
    name: 'transfer_pending',
    literal: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_16688_8274" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_16688_8274)">
      <path d="M7.36571 19.7885L6.65796 19.0807L8.71371 17.0078C6.95987 16.9231 5.44096 16.324 4.15696 15.2105C2.87296 14.0972 2.23096 12.6937 2.23096 11C2.23096 9.30633 2.83962 7.88292 4.05696 6.72975C5.27429 5.57658 6.73612 5 8.44246 5H10.5002V6H8.46171C7.02704 6 5.79662 6.48108 4.77046 7.44325C3.74412 8.40542 3.23096 9.591 3.23096 11C3.23096 12.4052 3.77779 13.5693 4.87146 14.4923C5.96496 15.4154 7.25079 15.9167 8.72896 15.9963L6.65796 13.925L7.36571 13.2115L10.654 16.5L7.36571 19.7885ZM13.5002 19V13.1923H21.0002V19H13.5002ZM13.5002 10.8078V5H21.0002V10.8078H13.5002ZM14.5002 9.80775H20.0002V6H14.5002V9.80775Z" fill="#94A3B8"/>
      </g>
    </svg>`,
  },
  // Insights 2.0 date range (Figma 19933:392212): the frames draw Material
  // Symbols at weight 200, thinner than the registered Material outline set.
  {
    namespace: 'pg',
    name: 'calendar_today_light',
    url: 'icons/custom/calendar_today_light.svg',
  },
  {
    namespace: 'pg',
    name: 'arrow_drop_down_light',
    url: 'icons/custom/arrow_drop_down_light.svg',
  },
  {
    namespace: 'pg',
    name: 'chevron_left_light',
    url: 'icons/custom/chevron_left_light.svg',
  },
  {
    namespace: 'pg',
    name: 'chevron_right_light',
    url: 'icons/custom/chevron_right_light.svg',
  },
  {
    namespace: 'pg',
    name: 'check_light',
    url: 'icons/custom/check_light.svg',
  },
  // Material Symbols arrow_*_alt, 20px, exported from the Insights legend's
  // delta badge (18757:232246, 18757:232248); not in the registered sets.
  {
    namespace: 'pg',
    name: 'arrow_downward_alt',
    url: 'icons/custom/arrow_downward_alt.svg',
  },
  {
    namespace: 'pg',
    name: 'arrow_upward_alt',
    url: 'icons/custom/arrow_upward_alt.svg',
  },
  // The Insights frames draw Material Symbols at weight 200 (the `*_light`
  // glyphs); none of these has a pixel match in the registered sets
  // (4742 icons scanned on 2026-10-23), so they come from Figma as drawn.
  {
    namespace: 'pg',
    name: 'tune_light',
    url: 'icons/custom/tune_light.svg',
  },
  {
    namespace: 'pg',
    name: 'balance_light',
    url: 'icons/custom/balance_light.svg',
  },
  {
    namespace: 'pg',
    name: 'bar_chart_light',
    url: 'icons/custom/bar_chart_light.svg',
  },
  {
    namespace: 'pg',
    name: 'show_chart_light',
    url: 'icons/custom/show_chart_light.svg',
  },
  {
    namespace: 'pg',
    name: 'all_inclusive_light',
    url: 'icons/custom/all_inclusive_light.svg',
  },
  {
    namespace: 'pg',
    name: 'check_box_light',
    url: 'icons/custom/check_box_light.svg',
  },
  {
    namespace: 'pg',
    name: 'check_box_outline_blank_light',
    url: 'icons/custom/check_box_outline_blank_light.svg',
  },
  {
    namespace: 'pg',
    name: 'search_light',
    url: 'icons/custom/search_light.svg',
  },
  {
    namespace: 'pg',
    name: 'add_light',
    url: 'icons/custom/add_light.svg',
  },
  {
    namespace: 'pg',
    name: 'minus_light',
    url: 'icons/custom/minus_light.svg',
  },
  {
    namespace: 'pg',
    name: 'add_circle_light',
    url: 'icons/custom/add_circle_light.svg',
  },
  {
    namespace: 'pg',
    name: 'do_not_disturb_on_light',
    url: 'icons/custom/do_not_disturb_on_light.svg',
  },
  // 20px glyphs of the State 2 sort row (18688:1153544)
  {
    namespace: 'pg',
    name: 'sort_by_alpha_light',
    url: 'icons/custom/sort_by_alpha_light.svg',
  },
  {
    namespace: 'pg',
    name: 'swap_vert_light',
    url: 'icons/custom/swap_vert_light.svg',
  },
  // 20px close of the settings chips (19737:563743)
  {
    namespace: 'pg',
    name: 'close_light',
    url: 'icons/custom/close_light.svg',
  },
];
